import { LoadingOutlined } from "@ant-design/icons";
const LoadingIcon = () => {
	return(
		<>
			<LoadingOutlined />
		</>
	)
}
export default LoadingIcon;